import React, { useState, useRef } from 'react'
import { API_BASE_URL } from '../../config/apiConfig'
import { makeApiCall } from '../../services/httpService_notinuse';
import { CSVLink } from "react-csv";
import toast from 'react-hot-toast';



const BulkInventoryUpload = () => {
  const [sampleFileData, setSampleFileData] = useState({
    data: [],
    fileName: 'Inventory_Data'
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const csvLinkRef = useRef(null);

  const handleSampleDownload = async () => {
    setIsDownloading(true);
    const url = `${API_BASE_URL}/api/inventory/bulkupload`;

    try {
      const apiRes = await makeApiCall('GET', null, url);
      if (apiRes.statusCode === 200) {
        // Update the state with the fetched data
        setSampleFileData({
          data: apiRes.resData.fileData,
          fileName: apiRes.resData.fileName
        });

        // Check if running in Capacitor (mobile app)
        // if (Capacitor.isNativePlatform()) {
        //   await downloadFileInApp(apiRes.resData.fileData, apiRes.resData.fileName);
        // } else {
        //   // For web browsers, use the existing CSVLink approach
        //   setTimeout(() => {
        //     if (csvLinkRef.current) {
        //       csvLinkRef.current.link.click();
        //     }
        //   }, 100);
        // }

        toast.success(apiRes.message);
      } else {
        toast.error('Something went wrong...');
      }
    } catch (error) {
      toast.error('Failed to download sample file');
      console.error('Download error:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  // const downloadFileInApp = async (data, fileName) => {
  //   try {
  //     // Convert data to CSV string
  //     const csvContent = convertToCSV(data);

  //     // Write file to device storage
  //     const result = await Filesystem.writeFile({
  //       path: `${fileName}.csv`,
  //       data: csvContent,
  //       directory: Directory.Documents,
  //       encoding: Encoding.UTF8
  //     });

  //     // Try to share the file so user can save it where they want
  //     //if uncommented, it will automatically open share dialog after download
  //     // try {
  //     //     await Share.share({
  //     //         title: 'Download CSV File',
  //     //         text: 'Your CSV file is ready',
  //     //         url: result.uri,
  //     //         dialogTitle: 'Save CSV File'
  //     //     });
  //     // } catch (shareError) {
  //     //     console.log('Share not available, file saved to Documents folder');
  //     //     toast.success(`File saved to Documents folder as ${fileName}.csv`);
  //     //     return;
  //     // }

  //     toast.success('File downloaded successfully!');
  //   } catch (error) {
  //     console.error('Error downloading file in app:', error);

  //     // Fallback: try to save to Downloads directory
  //     try {
  //       const csvContent = convertToCSV(data);
  //       await Filesystem.writeFile({
  //         path: `${fileName}.csv`,
  //         data: csvContent,
  //         directory: Directory.ExternalStorage,
  //         encoding: Encoding.UTF8
  //       });
  //       toast.success(`File saved to Downloads folder as ${fileName}.csv`);
  //     } catch (fallbackError) {
  //       console.error('Fallback download also failed:', fallbackError);
  //       toast.error('Failed to download file. Please try again.');
  //     }
  //   }
  // };

  const convertToCSV = (data) => {
    if (!data || data.length === 0) return '';

    // Get headers from the first object
    const headers = Object.keys(data[0]);
    const csvHeaders = headers.join(',');

    // Convert data rows to CSV format
    const csvRows = data.map(row => {
      return headers.map(header => {
        const value = row[header];
        // Handle values with commas, quotes, or newlines
        if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      }).join(',');
    });

    return [csvHeaders, ...csvRows].join('\n');
  };

  const handleFileUploadChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = () => {
    if (!selectedFile) {
      toast.error('Please Select a File');
      return;
    }
    console.log('File selected:', selectedFile);
  };

  return (
    <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e8ecf4", overflow: "hidden" }}>
      {/* Header */}
      <div style={{ padding: "16px 22px", borderBottom: "1px solid #f0f2f8", display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: "#eef0ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <i className="fa-solid fa-cloud-arrow-up" style={{ color: "#1a3a8f", fontSize: 16 }} />
        </div>
        <span style={{ fontWeight: 700, fontSize: 15, color: "#0f2557" }}>Bulk Inventory Upload</span>
      </div>

      <div style={{ padding: "28px 22px" }}>
        {/* Drop Zone */}
        <label
          style={{
            display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
            gap: 12, padding: "40px 24px", borderRadius: 12,
            border: "2px dashed #c7d0e8", background: "#f8f9fe",
            cursor: "pointer", transition: "border-color 0.2s",
            textAlign: "center"
          }}
          onMouseEnter={e => e.currentTarget.style.borderColor = "#1a3a8f"}
          onMouseLeave={e => e.currentTarget.style.borderColor = "#c7d0e8"}
        >
          <div style={{
            width: 56, height: 56, borderRadius: 14,
            background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 4px 14px rgba(15,37,87,0.25)"
          }}>
            <i className="fa-solid fa-cloud-arrow-up" style={{ color: "#fff", fontSize: 24 }} />
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: "#0f2557", marginBottom: 4 }}>
              Drag &amp; Drop a file here
            </div>
            <div style={{ fontSize: 13, color: "#8a9ab5" }}>
              or <span style={{ color: "#1a3a8f", fontWeight: 600 }}>click to browse</span> from your computer
            </div>
          </div>
          {selectedFile && (
            <div style={{
              display: "flex", alignItems: "center", gap: 8,
              padding: "6px 14px", borderRadius: 20,
              background: "#ecfdf5", border: "1px solid #a7f3d0"
            }}>
              <i className="fa-solid fa-file-csv" style={{ color: "#065f46", fontSize: 13 }} />
              <span style={{ fontSize: 13, fontWeight: 600, color: "#065f46" }}>{selectedFile.name}</span>
            </div>
          )}
          <input
            type="file"
            name="bulkdataupload"
            onChange={handleFileUploadChange}
            hidden
          />
        </label>

        {/* Format hint */}
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 10, marginBottom: 0 }}>
          <i className="bi bi-info-circle" style={{ color: "#8a9ab5", fontSize: 13 }} />
          <span style={{ fontSize: 12, color: "#8a9ab5" }}>Accepted format: <strong>.csv</strong> — Download the sample file to see the required column structure.</span>
        </div>

        {/* Footer Actions */}
        {/* Footer Actions */}
        <div style={{ display: "flex", flexDirection: "column", marginTop: 22, gap: 10 }}>
          <div>
            <CSVLink
              data={sampleFileData.data}
              filename={sampleFileData.fileName}
              className="text-decoration-none"
              ref={csvLinkRef}
              target="_blank"
              style={{ display: "none" }}
            />
            <button
              type="button"
              onClick={handleSampleDownload}
              disabled={isDownloading}
              style={{
                display: "flex", alignItems: "center", justifyContent: "center", gap: 7,
                width: "100%", padding: "10px 16px", borderRadius: 8,
                border: "1.5px solid #dde3ef", background: "#fff",
                color: "#1a3a8f", fontWeight: 600, fontSize: 13,
                cursor: isDownloading ? "not-allowed" : "pointer",
                opacity: isDownloading ? 0.7 : 1
              }}
            >
              <i className={`fa-solid ${isDownloading ? "fa-spinner fa-spin" : "fa-download"}`} style={{ fontSize: 13 }} />
              {isDownloading ? "Preparing Download..." : "Download Sample CSV"}
            </button>
          </div>

          <button
            onClick={handleUpload}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
              width: "100%", padding: "10px 24px", borderRadius: 8, border: "none",
              background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
              color: "#fff", fontWeight: 700, fontSize: 14,
              boxShadow: "0 4px 12px rgba(15,37,87,0.3)",
              cursor: "pointer"
            }}
          >
            <i className="fa-solid fa-cloud-arrow-up" style={{ fontSize: 14 }} />
            Upload Bulk Inventory
          </button>
        </div>
      </div>
    </div>
  )
};

export default BulkInventoryUpload;
